import { migration as initial } from "./001_initial";
import { migration as renameReleaseToPickup } from "./002_rename_release_to_pickup";
import { migration as multiVehicleBookingLines } from "./003_multi_vehicle_booking_lines";
import { migration as extraHoursFields } from "./004_extra_hours_fields";

export const migrations = [initial, renameReleaseToPickup, multiVehicleBookingLines, extraHoursFields];
